export default __webpack_public_path__ + "images/698b5e0570de26c40d1eafc621313c03-bushs_beans_desktop.webp";